import { useState, useEffect } from "react";
import axios from "axios";
import { useParams} from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import SwitchBox from "../../components/switchBox";
import {switchHelper, dateHelper } from "../../modules/helpers";
import { member, order_by_memberId, file_upload } from '../../components/apipath';

function AdmMemberEdit() {
    const {mem_id} = useParams();
    const { token } = useAuth();
    const [memberData, setMemberData] = useState();
    const [orderData, setOrderData] = useState({});
    const memberStatus = ['請選擇', '在職者', "在學生", "全職考生", "待業中"];
    const userType = ['請選擇', 'CPA', 'CMA'];

    const fetchData = async (id) => {
        try{
            const response = await axios.get(`${member}${id}`, {headers:{token: token}});
            setMemberData(response.data[0]); 
        } catch(error) {
            console.error(error);
        }
    }

    const fetchOrderData = async (id) => {
        try{
            const response = await axios.get(`${order_by_memberId}${id}`, {headers:{token: token}});
            setOrderData(response.data.data[0]); 
        } catch(error) {
            console.error(error);
        }
    }

    useEffect(()=>{fetchData(mem_id)}, []);
    useEffect(()=>{fetchOrderData(mem_id)}, []);

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setMemberData({
                ...memberData,
                [name]: switchHelper(checked),
            });
        } else {
            setMemberData({
                ...memberData,
                [name]: value,
            });
        }
    }

    const handleSave = async (e) => {
        const response = await axios.put(`${member}`, memberData, {headers:{token: token}});
            if (response.data.status === 200){
                alert('更新成功！');
            } else {
                console.error('Error saving new product:', response.data.msg);
            }
    }

    return (
        <>
            <div className="container" style={{marginTop:"50px"}}>
                <div className="row g-2">
                    <div className="col-12 text-center">
                        <h3 className="fw-bold">學生資料</h3>
                    </div>
                    <div className="col-12">
                        <hr></hr>
                    </div>
                    { memberData && (
                        <>
                            <div className="col-xl-2 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('account_status', memberData.account_status, handleInputChange, "帳戶狀態")}
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-sm-6 col-12">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('mem_status', memberData.mem_status, handleInputChange, "正式會員")}
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('pass', memberData.pass, handleInputChange, "已通過")}
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('refund', memberData.refund, handleInputChange, "已退費")}
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('postpone', memberData.postpone, handleInputChange, "展延")}
                                </div>
                                {switchHelper(memberData.postpone) ? (
                                    <div className="text-muted">
                                        <input type="date" defaultValue={dateHelper(memberData.postpone_date, 'date')} name="postpone_date" onChange={handleInputChange}/>
                                    </div>
                                ) : ""}
                            </div>
                            <div className="col-12">
                                <hr/>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">創建日期</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="date" 
                                        name="createtime" 
                                        defaultValue={dateHelper(memberData.createtime, 'date')} 
                                        required 
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">購買日期</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="date" 
                                        name="purchase_date" 
                                        defaultValue={dateHelper(memberData.purchase_date, 'date')} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">啟用日期</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="date" 
                                        name="active_date" 
                                        defaultValue={dateHelper(memberData.active_date, 'date')} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>    
                            <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">數位點數</span>
                                    <input
                                        className="form-control form-control-sm"
                                        type="number"
                                        name="total_points"
                                        value={(memberData.total_points)}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>用戶狀態
                                    </span>
                                    <select 
                                        className="form-select form-select-sm" 
                                        name="status" 
                                        value={memberData.status} 
                                        onChange={handleInputChange}
                                        required
                                    >
                                        {memberStatus.map((item, index)=>(
                                            <option key={index} value={index===0 ? '' : index}>{item}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>                       
                            <div className="col-12">
                                <hr/>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>中文姓名
                                    </span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="chinese_name" 
                                        defaultValue={memberData.chinese_name} 
                                        maxLength={24}
                                        required 
                                        onChange={handleInputChange} 
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">帳號</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="account" 
                                        defaultValue={memberData.account} 
                                        required 
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>密碼
                                    </span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="password" 
                                        name="password" 
                                        defaultValue={memberData.password} 
                                        required 
                                        onChange={handleInputChange} 
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>科目
                                    </span>
                                    <select 
                                        className="form-select form-select-sm" 
                                        name="user_type" 
                                        value={memberData.user_type} 
                                        onChange={handleInputChange}
                                    >
                                        {userType.map((item, index)=>(
                                            <option key={index} value={index===0 ? '' : item}>{item}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">英文名字</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="first_name" 
                                        maxLength={200}
                                        defaultValue={memberData.first_name} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">英文姓氏</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="last_name" 
                                        maxLength={200}
                                        defaultValue={memberData.last_name} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">權限</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="auth" 
                                        maxLength={10}
                                        defaultValue={memberData.auth} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>證件號碼
                                    </span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="id_num" 
                                        maxLength={20}
                                        defaultValue={memberData.id_num} 
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>連絡電話
                                    </span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="phone_num" 
                                        maxLength={40}
                                        defaultValue={memberData.phone_num} 
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>Email
                                    </span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="email" 
                                        maxLength={255}
                                        defaultValue={memberData.email} 
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6 col-md-6 col-12">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                        <i className="fa-regular fa-star fa-fw text-danger me-1"></i>地址
                                    </span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="address" 
                                        maxLength={255}
                                        defaultValue={memberData.address} 
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">學校</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="school" 
                                        maxLength={255}
                                        defaultValue={memberData.school} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">專業</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="major" 
                                        maxLength={255}
                                        defaultValue={memberData.major} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">年級</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="grade" 
                                        maxLength={255}
                                        defaultValue={memberData.grade} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">產業</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="industry" 
                                        maxLength={255}
                                        defaultValue={memberData.industry} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">公司</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="company_name" 
                                        maxLength={255}
                                        defaultValue={memberData.company_name} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-3 col-6">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">如何得知Becker</span>
                                    <input 
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="info_way" 
                                        maxLength={255}
                                        defaultValue={memberData.info_way} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-12"></div>
                            
                            <div className="col-xl-11 col-12">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">備註</span>
                                    <textarea
                                        className="form-control form-control-sm" 
                                        type="text" 
                                        name="comment" 
                                        rows={10}
                                        defaultValue={memberData.comment} 
                                        onChange={handleInputChange}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="col-xl-1 col-12">
                                <div className="m-2 text-center">
                                    <a href={`${file_upload}member/${mem_id}/mResume`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">履歷</a>
                                    <a href={`${file_upload}member/${mem_id}/mTranscript`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">成績單</a>
                                    <a href={`${file_upload}member/${mem_id}/mInterview`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">諮詢紀錄</a>
                                    <a href={`${file_upload}member/${mem_id}/mApplication`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">報考文件</a>
                                    <a href={`${file_upload}member/${mem_id}/mAcademic`} target="_blank" rel="noreferrer" className="btn btn-sm w-100 btn-primary m-1">學歷認證</a>
                                    <button className="btn btn-sm w-100 btn-danger m-1" onClick={handleSave}>儲存</button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <hr/>
                <div className="row g-2 table-responsive mt-2 mb-3">
                    <div className="col-12">
                        <h5 className="fw-bold">購買紀錄</h5>
                    </div>
                    <div className="col-12">
                        <table className="table table-hover table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Order Id</th>
                                    <th scope="col">產品</th>
                                    <th scope="col">折扣</th>
                                    <th scope="col">MOU</th>
                                    <th scope="col">通路</th>
                                    <th scope="col">總金額</th>
                                    <th scope="col">日期</th>
                                    <th scope="col">擴展</th>
                                    <th scope="col">備註</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderData && (
                                    <tr>
                                        <td>{orderData.order_id}</td>
                                        <td>{orderData.product}</td>
                                        <td>{orderData.discount}</td>
                                        <td>{orderData.mou}</td>
                                        <td>{orderData.partner}</td>
                                        <td>{orderData.total_price}</td>
                                        <td>{dateHelper(orderData.software_ex, 'date')}</td>
                                        <td>{orderData.extension}</td>
                                        <td>{orderData.memo}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}
export default AdmMemberEdit;